/* DBW · tap-a-size quick add for product cards (homepage product tabs). Oct 2026.
   Buttons: <button class="dbw-chip" data-variant-id="...">. Adds 1 to cart, then fires the theme's
   cart:update event with the re-rendered cart sections so the cart drawer updates/opens like a normal add. */
(function () {
  if (window.__dbwSizeChips) return;
  window.__dbwSizeChips = true;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('.dbw-chip') : null;
    if (!btn || btn.disabled || btn.getAttribute('aria-busy') === 'true') return;
    e.preventDefault();
    var id = btn.getAttribute('data-variant-id');
    var wrap = btn.closest('.dbw-chips');
    var msg = wrap ? wrap.querySelector('.dbw-chips__msg') : null;
    var ids = [];
    document.querySelectorAll('cart-items-component').forEach(function (el) { if (el.dataset.sectionId) ids.push(el.dataset.sectionId); });
    btn.setAttribute('aria-busy', 'true');
    btn.classList.add('is-loading');
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }], sections: ids.join(','), sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        if (!res.ok || res.d.status) throw new Error(res.d.description || res.d.message || 'Sorry, we could not add that size.');
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: { resource: {}, sourceId: String(id), data: { source: 'dbw-size-chips', itemCount: 1, variantId: String(id), productId: wrap ? wrap.getAttribute('data-product-id') : '', sections: res.d.sections } }
        }));
        var label = btn.textContent;
        btn.classList.add('is-added');
        btn.textContent = 'Added ✓';
        if (msg) msg.textContent = '';
        setTimeout(function () { btn.textContent = label; btn.classList.remove('is-added'); }, 1600);
      })
      .catch(function (err) {
        btn.classList.add('is-error');
        if (msg) { msg.textContent = err.message; setTimeout(function () { msg.textContent = ''; }, 5000); }
        setTimeout(function () { btn.classList.remove('is-error'); }, 1600);
      })
      .finally(function () { btn.removeAttribute('aria-busy'); btn.classList.remove('is-loading'); });
  });
})();